import { rpcSpecification } from "#root/bin/server/client/ep/endpoints";
import { legalRpcSpec } from "#root/bin/server/client/ep/endpointsLegal";
import { makeClientEndpoints } from "../../../lib/rpc";

export const endpoints = makeClientEndpoints({
  ...rpcSpecification,
  ...legalRpcSpec,
});
